import { render } from "./FransysSignature.vue?vue&type=template&id=d3dd71bc&scoped=true&ts=true"
import script from "./FransysSignature.vue?vue&type=script&lang=ts"
export * from "./FransysSignature.vue?vue&type=script&lang=ts"

import "./FransysSignature.vue?vue&type=style&index=0&id=d3dd71bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3dd71bc"]])

export default __exports__